// src/pages/DonationsPage.jsx
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE } from "../config";
import "../styles/DonationsPage.css";

export default function DonationsPage() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr("");
      try {
        const res = await fetch(`${API_BASE}/api/Donation/all`);
        if (!res.ok) {
          throw new Error(`API returned ${res.status}`);
        }
        const data = await res.json();

        // backend returns ShortDonation:
        // { name, amount, dedicatedTo, createdAt }
        const sorted = Array.isArray(data)
          ? data
              .map((d) => ({
                name: d.name ?? "",
                amount: typeof d.amount === "number" ? d.amount : Number(d.amount ?? 0),
                dedicatedTo: d.dedicatedTo ?? "",
                createdAt: d.createdAt ?? d.CreatedAt ?? null,
              }))
              .sort((a, b) => {
                const da = a.createdAt ? new Date(a.createdAt) : 0;
                const db = b.createdAt ? new Date(b.createdAt) : 0;
                return db - da;
              })
          : [];

        setDonations(sorted);
      } catch (e) {
        console.error(e);
        setErr("Unable to load donations right now.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <div className="donations-page">
      <Header />

      <main className="donations-content">
        <div className="donations-panel">
          <h1 className="donations-title">All Donations</h1>
          <p className="donations-sub">
            Thank you to everyone who has supported the Gail Thompson Foundation.
          </p>

          {loading && <div className="donations-status">Loading…</div>}
          {err && <div className="donations-error">{err}</div>}

          {!loading && !err && (
            <div className="donations-list">
              {donations.length === 0 ? (
                <div className="donations-empty">No donations yet.</div>
              ) : (
                donations.map((d, idx) => (
                  <div
                    key={`${d.name}-${d.createdAt ?? idx}`}
                    className="donation-row"
                  >
                    <div className="donation-left">
                      <div className="donation-name">
                        {d.name?.trim() ? d.name : "Anonymous"}
                      </div>
                      <div className="donation-meta">
                        {d.dedicatedTo?.trim()
                          ? `Dedicated to: ${d.dedicatedTo}`
                          : ""}
                        {" · "}
                        {d.createdAt
                          ? new Date(d.createdAt).toLocaleDateString()
                          : ""}
                      </div>
                    </div>
                    <div className="donation-amount">
                      ${d.amount.toFixed(2)}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}
